import RideAPI from "services/ride";
import swalState from "utility/swal";
import { message } from "antd";

function handleError(err) {
    console.error("Error in ride actions: ", err);
    message.error(err.message);
}

export function setRideDetails(payload) {
    return {
        type: "SET_RIDE_DETAILS",
        payload,
    };
}

export const getRideDetails = (rideId) => async (dispatch) => {
    try {
        swalState.showLoader();
        let response = await RideAPI.getRideById(rideId);
        if (response) {
            swalState.hideLoader();
            dispatch(setRideDetails(response.data));
        }
    } catch (err) {
        swalState.hideLoader();
        handleError(err);
    }
};

export const updateRideImage = (rideId, imageURL) => (dispatch) => {
    dispatch({
        type: 'UPDATE_RIDE_IMAGE',
        payload: { rideId, imageURL }
    });
};